import ProductsView from '@/products/ProductsView.vue'
import ProductDetailsView from '@/products/ProductDetailsView.vue'
import { PanelContent } from '@tritt/multipanel'

export const PRODUCTS_VIEW: PanelContent = {
    componentName: 'Products',
    component: ProductsView,
    meta: { requiresOrg: true }
}

export const PRODUCT_DETAILS_VIEW: PanelContent = {
    componentName: 'ProductDetails',
    component: ProductDetailsView,
    meta: { requiresOrg: true }
}

